import React from 'react';
import { Main } from '../../components';

export const AdminPlaceholder = React.memo(() => <Main>{null}</Main>);
